// extracted by mini-css-extract-plugin
module.exports = {"form":"Company_form__2v7e5","actionContainer":"Company_actionContainer__1TWu_"};